import { ENakupProdej } from 'enums/isin/udaje/warrNakupProdej';

const warrNakupProdejSelect = [
    {
        value: ENakupProdej.N,
        labelcz: 'ISIN_EMISE_WARRANT_WARR_N'
    },
    {
        value: ENakupProdej.P,
        labelcz: 'ISIN_EMISE_WARRANT_WARR_P'
    },
    {
        value: ENakupProdej.NK,
        labelcz: 'ISIN_EMISE_WARRANT_WARR_NP'
    }
];

export default warrNakupProdejSelect;
